var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTasksIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: "#262a2e",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M324.67-298.46q13.1 0 21.91-8.86 8.8-8.86 8.8-21.96 0-13.1-8.86-21.91T324.56-360q-13.1 0-21.91 8.86-8.8 8.86-8.8 21.96 0 13.1 8.86 21.91t21.96 8.81Zm0-150.77q13.1 0 21.91-8.86 8.8-8.86 8.8-21.96 0-13.1-8.86-21.91t-21.96-8.81q-13.1 0-21.91 8.86-8.8 8.86-8.8 21.96 0 13.1 8.86 21.91t21.96 8.81Zm0-150.77q13.1 0 21.91-8.86 8.8-8.86 8.8-21.96 0-13.1-8.86-21.91t-21.96-8.81q-13.1 0-21.91 8.86-8.8 8.86-8.8 21.96 0 13.1 8.86 21.91t21.96 8.81Zm123.02 290.77h215.39v-40H447.69v40Zm0-150.77h215.39v-40H447.69v40Zm0-150.77h215.39v-40H447.69v40ZM224.62-160q-27.62 0-46.12-18.5Q160-197 160-224.62v-510.76q0-27.62 18.5-46.12Q197-800 224.62-800h510.76q27.62 0 46.12 18.5Q800-763 800-735.38v510.76q0 27.62-18.5 46.12Q763-160 735.38-160H224.62Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTasksIcon);
export default __webpack_public_path__ + "static/media/tasks_icon.58926fcf3c7606da7ebe7aaafaaf17f7.svg";
export { ForwardRef as ReactComponent };